export default {"src":"/_next/static/media/viewers3.5ce77e4e.svg","height":1085,"width":1340};